import { render, staticRenderFns } from "./Ordhis.vue?vue&type=template&id=07a80790&scoped=true"
import script from "./Ordhis.vue?vue&type=script&lang=js"
export * from "./Ordhis.vue?vue&type=script&lang=js"
import style0 from "./Ordhis.vue?vue&type=style&index=0&id=07a80790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a80790",
  null
  
)

export default component.exports